"use strict";

exports.wrapPageElement = require('./wrap-blog');